import React from "react";
import ReactGA from "react-ga4";
import {
  ITrackingPlugin,
  TTrackingEventOptions,
  TTrackingModalViewOptions,
  TTrackingPageViewOptions,
  TTrackingPluginInitConfiguration
} from "./plugin";

const GoogleAnalyticsTrackingPlugin = (): ITrackingPlugin => ({
  init(config: TTrackingPluginInitConfiguration) {
    if (!config) {
      return;
    }
    const { trackingId, options } = config;
    ReactGA.initialize([
      {
        trackingId,
        gaOptions: options
      }
    ]);
  },
  setProperty(fieldValues: any) {
    ReactGA.set(fieldValues);
  },
  trackPageView(options: TTrackingPageViewOptions) {
    if (!options) {
      return;
    }
    const { path } = options;
    ReactGA.send({
      hitType: "pageview",
      page: path
    });
  },
  trackModalView(options: TTrackingModalViewOptions) {
    if (!options) {
      return;
    }
    const { name } = options;
    ReactGA.send({
      hitType: "modalview",
      page: name
    });
  },
  trackEvent(event: TTrackingEventOptions) {
    if (!event) {
      return;
    }
    ReactGA.event(event);
  }
});
export default GoogleAnalyticsTrackingPlugin;
